// components/Desktop/Components/Safe2.js
import React from 'react';
import styles from './Safe2.module.css';

// Replace with your actual image paths
import asset1 from '../../../assets/safe2-asset-1.png';
import asset2 from '../../../assets/safe2-asset-2.png';
import asset3 from '../../../assets/safe2-asset-3.png';
import asset4 from '../../../assets/safe2-asset-4.png';
import asset5 from '../../../assets/safe2-asset-5.png';

const Safe2 = () => {
  return (
    <section className={styles.safe2Section}>
      {/* Background Images */}
      <img src={asset1} alt="Asset 1" className={styles.asset1} />
      <img src={asset2} alt="Asset 2" className={styles.asset2} />
      <img src={asset3} alt="Asset 3" className={styles.asset3} />
      <img src={asset4} alt="Asset 4" className={styles.asset4} />
      <img src={asset5} alt="Asset 5" className={styles.asset5} />

      {/* Text Content */}
        <h2 className={styles.topLine}>
         SAFE
        </h2>
        <h1 className={styles.bottomTitle}>User-backed trust ratings</h1>
        <h2 className={styles.midText}>Take charge in creating a<br />safe community</h2>
        <h2 className={styles.bottomText}> The user-backed trust rating system is made<br />to foster trust and community</h2>
    </section>
  );
};

export default Safe2;
